import { ScheduleContactHelper } from '..';

export const useScheduleContact = () => {
	let scheduleContactHelper = new ScheduleContactHelper();
	return {
		scheduleContactHelper,
		activeScheduleContact: scheduleContactHelper.active()
	};
};
